import apiClient from '@src/api/clients';

const BASE_URL = 'app1/task-loggers/';

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
  );

export const listTaskLogs = (params = {}) =>
  apiClient.request({ url: BASE_URL, method: 'GET', payload: cleanParams(params) });

export const fetchTaskLog = (id, { includeMessages = false } = {}) =>
  apiClient.request({
    url: `${BASE_URL}${id}/`,
    method: 'GET',
    payload: includeMessages ? { include_messages: 'true' } : {},
  });

// Per-family rollup for the "By job" tab (window = 24h | 7d | 30d).
export const fetchTaskLogSummary = (params = {}) =>
  apiClient.request({ url: `${BASE_URL}summary/`, method: 'GET', payload: cleanParams(params) });

export default {
  listTaskLogs,
  fetchTaskLog,
  fetchTaskLogSummary,
};
